import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledCrmEnrichmentJobBanner = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: fit-content;
    padding: 12px 16px;
    border-radius: 3px;
    background-color: ${colorsPalettes.bluegrey[200]};
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};
`;
